import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAsyncAction } from '../hooks/useAsyncAction';
import AuthCard from '../components/AuthCard';
import { authStyles } from '../styles/authStyles';

export default function SignupPage() {
  const { signup, teacher } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isUpgrade = searchParams.get('upgrade') === 'true';

  const [form, setForm] = useState({
    email: '',
    password: '',
    classroom_name: teacher?.classroom_name || '',
    agreed_to_terms: false,
  });
  const { loading, error, setError, run } = useAsyncAction();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.agreed_to_terms) {
      setError('Please agree to the Terms of Service and Privacy Policy to continue');
      return;
    }
    await run(async () => {
      await signup(form.email, form.password, form.classroom_name, form.agreed_to_terms, isUpgrade);
      // After signup, go to subscribe page (organic path goes to Stripe)
      navigate('/subscribe');
    });
  };

  return (
    <AuthCard maxWidth="420px">
      <h1 style={authStyles.heading}>
        {isUpgrade ? 'Save your account' : 'Create your account'}
      </h1>
      <p style={authStyles.sub}>
        {isUpgrade
          ? 'Add an email and password to keep your TpT novel access between visits.'
          : 'Full library access for $19.99/year. Cancel anytime.'}
      </p>

      {error && <div style={authStyles.error}>{error}</div>}

      <form onSubmit={handleSubmit} style={authStyles.form}>
        <label style={authStyles.label}>
          Email address
          <input
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            style={authStyles.input}
            required
            autoComplete="email"
          />
        </label>
        <label style={authStyles.label}>
          Password
          <input
            type="password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            style={authStyles.input}
            required
            autoComplete="new-password"
            minLength={8}
          />
          <span style={{ fontSize: '12px', color: '#9ca3af', marginTop: '2px' }}>
            At least 8 characters
          </span>
        </label>
        <label style={authStyles.label}>
          Classroom name
          <input
            type="text"
            value={form.classroom_name}
            onChange={(e) => setForm({ ...form, classroom_name: e.target.value })}
            style={authStyles.input}
            required
            placeholder="e.g. Ms. Johnson's 5th Grade"
          />
          <span style={{ fontSize: '12px', color: '#9ca3af', marginTop: '2px' }}>
            Shown at the top of student bingo boards
          </span>
        </label>
        <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', fontSize: '13px', color: '#374151', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={form.agreed_to_terms}
            onChange={(e) => setForm({ ...form, agreed_to_terms: e.target.checked })}
            style={{ marginTop: '2px', flexShrink: 0 }}
          />
          <span>
            I agree to the{' '}
            <a href="/terms" target="_blank" rel="noreferrer" style={authStyles.link}>Terms of Service</a>
            {' '}and{' '}
            <a href="/privacy" target="_blank" rel="noreferrer" style={authStyles.link}>Privacy Policy</a>
          </span>
        </label>
        <button type="submit" disabled={loading} style={authStyles.button}>
          {loading ? 'Creating account…' : isUpgrade ? 'Save my account' : 'Create account'}
        </button>
      </form>

      <div style={authStyles.footer}>
        Already have an account?{' '}
        <Link to="/login" style={authStyles.link}>Log in</Link>
      </div>
    </AuthCard>
  );
}
